import { useEffect, useState } from 'react'

import { Link, useNavigate, useParams } from 'react-router-dom'
import { Charging } from '../ui/Charging'
import { ReportPallet } from './ReportData/ReportPallet'
import { BatchInfo } from '../ui/BatchInfo';
import { useReport } from '../../api/useReport';
import Badge from '../ui/Badge'
import { MainData } from './Inputs/MainData'
import { LifeButton } from '../ui/LifeButton';
import { Comments } from '../ui/Comments';
import { ReportPalletNew } from './ReportData/ReportPalletNew';
import { useIsNewReport } from '../../hooks/useIsNewReport';
import { IoMailOutline } from 'react-icons/io5';
import { BsPersonCheck } from "react-icons/bs";
import { SelectReportDate } from '../ui/SelectReportDate';
import { GGNComponent } from '../ggn/GGNComponent';
import { ModalCreatePDF } from '../ui/ModalCreatePDF';
import { LuFileSymlink } from "react-icons/lu";
import { RiFilePdf2Line } from "react-icons/ri";
import { ModalSharePDF } from '../ui/ModalSharePDF';


export const Report = () => {

    const navigate = useNavigate()

    const { id } = useParams<string>()
    const { data, isLoading, isError } = useReport(id!)

    useEffect(() => {
        if (data?.unfinished) navigate(`/create-report/${id!}`)
    }, [data])

    const [openPDFModal, setOpenPDFModal] = useState(false)
    const [openCreatePDF, setOpenCreatePDF] = useState(false)

    const isNewReport = useIsNewReport(data?.date)

    if (isError) navigate('/')

    return (
        <div className="content">
            {
                isLoading || !data
                    ? <Charging />
                    :
                    <main className="container">

                        {
                            openPDFModal &&
                            <ModalSharePDF
                                report={data}
                                closeModal={() => setOpenPDFModal(false)}
                            />
                        }

                        {
                            openCreatePDF &&
                            <ModalCreatePDF
                                report={data}
                                closeModal={() => setOpenCreatePDF(false)}
                            />
                        }

                        {
                            data &&
                            <>
                                <div>

                                    <div className="report">

                                        <div className="mb-2">
                                            <div className='flex-space-between-top mb-1'>
                                                <h2 className='font-large flex-1 mr-1'>{data.mainData.pallet_ref}</h2>
                                                <LifeButton data={data} />
                                            </div>
                                            {
                                                data?.team &&
                                                <div className='flex mb-1'>
                                                    {/* <Badge icon="team-done" mr>
                                                        {teamName([...teamsOwner, ...teamsUser], data.team)}
                                                    </Badge> */}

                                                    {
                                                        data.user &&
                                                        <Badge iconReact={BsPersonCheck} isCreated>
                                                            {data.user.name || "--"} {data.user.lastname || ""}
                                                        </Badge>
                                                    }

                                                    {/* {
                                                        teamInCharge([...teamsOwner, ...teamsUser], data.team, data.user) &&
                                                        <Badge color='grey'>
                                                            {teamInCharge([...teamsOwner, ...teamsUser], data.team, data.user) || "--"}
                                                        </Badge>
                                                    } */}
                                                </div>
                                            }
                                            {(data.date) && <SelectReportDate id={id!} date={new Date(data.date)} />}
                                        </div>
                                    </div>
                                    <div className='flex'>
                                        <BatchInfo reportId={id!} mainData={data?.mainData} />
                                        <GGNComponent
                                            reportId={id!}
                                            weather={data?.weather || []}
                                            mainData_loading_date={ ( data?.mainData.harvest_day || data?.mainData.loading_date) ? new Date(data?.mainData.harvest_day || data?.mainData.loading_date) : new Date()} />
                                    </div>

                                    <div className='mb-2 tw-bg-white tw-rounded-lg tw-shadow-xl tw-p-4 tw-shadow-blue-800/10'>
                                        <MainData
                                            mainData={data?.mainData}
                                            reportId={id!}
                                            isList
                                            mainDataImages={data?.mainDataImages || []}
                                        />
                                    </div>

                                    {
                                        data.pallets.length > 0

                                            ?
                                            isNewReport
                                                ?
                                                <ReportPalletNew
                                                    pallets={data.pallets}
                                                    reportId={id!}
                                                    fruit={data.fruit}
                                                    samples={data.mainData.samples}
                                                />
                                                : <ReportPallet
                                                    pallets={data.pallets}
                                                    format={Number(data.mainData.format_gr || data.formatGr || 0)}
                                                    reportId={id}
                                                    fruit={data.fruit}
                                                    samples={data.mainData.samples}
                                                    date={data.date || new Date()}
                                                />


                                            : <p>No Pallets</p>
                                    }

                                    {
                                        (data) &&
                                        <Comments comments={data.comments} reportId={data._id} />
                                    }
                                </div>

                                <div className="tw-flex tw-gap-2">

                                    <button
                                        className="tw-bg-green-600 tw-rounded-full tw-px-5 tw-py-2 tw-flex tw-gap-1 tw-items-center"
                                        onClick={() => setOpenCreatePDF(true)}
                                    >
                                        <LuFileSymlink color='white' size={20} />
                                        <p className='tw-text-white tw-text-[0.8rem] sm:tw-text-md'>Create</p>
                                    </button>

                                    {
                                        data.pdf
                                            ?
                                            <Link to={data.pdf} target="_blank" className="tw-bg-red-500 tw-rounded-full tw-px-5 tw-py-2 tw-flex tw-items-center tw-gap-1">
                                                <RiFilePdf2Line color='white' size={20} />
                                                <p className='tw-text-white tw-text-[0.8rem] sm:tw-text-md'>PDF</p>
                                            </Link>
                                            :
                                            <Link to={`/view-pdf/${id}`} target="_blank" className="tw-bg-red-500 tw-rounded-full tw-px-5 tw-py-2 tw-flex tw-items-center tw-gap-1">
                                                <RiFilePdf2Line color='white' size={20} />
                                                <p className='tw-text-white tw-text-[0.8rem] sm:tw-text-md'>View PDF</p>
                                            </Link>
                                    }

                                    {
                                        data.pdf &&
                                        <button
                                            className="tw-bg-blue-600 tw-text-white tw-rounded-full tw-px-5 tw-py-2 tw-flex tw-gap-1 tw-items-center"
                                            onClick={() => setOpenPDFModal(true)}
                                        >
                                            <IoMailOutline color='white' size={20} />
                                            <p className='tw-text-white tw-text-[0.8rem] sm:tw-text-md'>Share</p>
                                        </button>
                                    }

                                </div>
                            </>
                        }
                    </main>
            }
        </div>
    );
}
